(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-features"] && !Shopify.designMode) return;
  try {
    

const initVitalFeatures=()=>{document.querySelectorAll('[data-vs-features]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-feature-card]')],buttons=[...root.querySelectorAll('[data-feature-button]')];let current=0;const show=i=>{current=(i+cards.length)%cards.length;cards.forEach((card,index)=>card.hidden=index!==current);buttons.forEach((button,index)=>button.setAttribute('aria-pressed',String(index===current)))};buttons.forEach((button,i)=>button.addEventListener('click',()=>show(i)));root.querySelector('[data-feature-prev]').addEventListener('click',()=>show(current-1));root.querySelector('[data-feature-next]').addEventListener('click',()=>show(current+1))})};initVitalFeatures();document.addEventListener('shopify:section:load',initVitalFeatures);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-header"] && !Shopify.designMode) return;
  try {
    

const initVitalHeader=()=>{document.querySelectorAll('.vs-menu-toggle').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';const nav=document.getElementById(button.getAttribute('aria-controls'));button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open)});nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{button.setAttribute('aria-expanded','false');nav.classList.remove('is-open')}));document.addEventListener('keydown',event=>{if(event.key==='Escape'){button.setAttribute('aria-expanded','false');nav.classList.remove('is-open')}})})};initVitalHeader();document.addEventListener('shopify:section:load',initVitalHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-product"] && !Shopify.designMode) return;
  try {
    

const initVitalProduct=()=>{document.querySelectorAll('[data-vs-gallery]').forEach(gallery=>{if(gallery.dataset.ready)return;gallery.dataset.ready='true';const slides=[...gallery.querySelectorAll('[data-gallery-slide]')],thumbs=[...gallery.querySelectorAll('[data-gallery-index]')],counter=gallery.querySelector('[data-gallery-counter]');let current=0,startX=0;const show=index=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==current);thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===current)));counter.textContent=(current+1)+' / '+slides.length;thumbs[current]?.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'})};thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));gallery.querySelector('[data-gallery-next]').addEventListener('click',()=>show(current+1));gallery.querySelector('[data-gallery-prev]').addEventListener('click',()=>show(current-1));const stage=gallery.querySelector('.vs-gallery-stage');stage.addEventListener('touchstart',event=>{startX=event.changedTouches[0].clientX},{passive:true});stage.addEventListener('touchend',event=>{const diff=event.changedTouches[0].clientX-startX;if(Math.abs(diff)>45)show(current+(diff<0?1:-1))},{passive:true})});document.querySelectorAll('.vs-buy-form').forEach(form=>{if(form.dataset.ready)return;form.dataset.ready='true';form.querySelectorAll('input[name="id"]').forEach(radio=>radio.addEventListener('change',()=>{document.querySelectorAll('.vs-buy-form').forEach(other=>{const matching=other.querySelector('input[name="id"][value="'+radio.value+'"]');if(!matching)return;matching.checked=true;other.querySelector('[data-selected-price]').textContent=radio.dataset.kitPrice;other.querySelector('[data-selected-cta]').textContent=radio.dataset.kitCta});const url=new URL(window.location.href);url.searchParams.set('variant',radio.value);window.history.replaceState({},'',url)}))});const sticky=document.querySelector('[data-sticky-buy]'),main=document.querySelector('[data-vs-product]');if(sticky&&main&&!sticky.dataset.ready){sticky.dataset.ready='true';new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||main.getBoundingClientRect().top>0},{threshold:0}).observe(main)}};initVitalProduct();document.addEventListener('shopify:section:load',initVitalProduct);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-routine"] && !Shopify.designMode) return;
  try {
    

const initVitalRoutine=()=>{document.querySelectorAll('[data-vs-routine]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const steps=[...root.querySelectorAll('[data-step]')],images=[...root.querySelectorAll('[data-step-image]')];steps.forEach(step=>step.addEventListener('toggle',()=>{if(!step.open)return;steps.forEach(other=>{if(other!==step)other.open=false});images.forEach(image=>image.hidden=image.dataset.stepImage!==step.dataset.step)}))})};initVitalRoutine();document.addEventListener('shopify:section:load',initVitalRoutine);


  } catch(e) { console.error(e); }
})();
})();
